<!--
 * @Author: your name
 * @Date: 2020-10-13 15:47:23
 * @LastEditTime: 2022-12-09 13:44:31
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/Process/index.vue
-->
<style lang="sass" scoped>
.progress_bar
  position: relative
  left: 0
  top: 0

  .bar_bg
    height: 10px
    background: rgba(51,68,85,1)
    opacity: 0.08
    border-radius: 6px

  .bar_active
    position: absolute
    left: 0
    top: 0
    height: 100%
    border-radius: 6px

.status
  margin-bottom: 10px
  font-size: 12px
  display: flex
  flex-direction: row
  flex-wrap: nowrap
  align-content: center
  align-items: center

  .statusIcon
    width: 69px
    height: 23px
    background: #46D666 0% 0% no-repeat padding-box
    border-radius: 12px
    text-align: center
    font: normal normal bold 12px/16px Roboto
    letter-spacing: -0.45px
    color: #FFFFFF
    display: flex
    flex-wrap: nowrap
    align-content: center
    justify-content: center
    align-items: center

  .yellow
    background-color: #FFCE00

  .dark_green
      background-color: #12501e

  .error_text
    margin-left: 4px
    font-weight: 500

.red
  color: rgba(176, 6, 32, 1)

strong
  margin-right: 5px
</style>

<template lang="pug">
.progress_component(v-if="style")
  .status
    strong {{ t('status', 'Status:') }}
    span(:class="[{red: status >= 40 && type && payamentStatus !== 1, statusIcon: this.enableStation}, getStatusClass]") {{ style.text }}
    small.red.error_text(v-if="showError") (ERROR)
  .progress_bar(v-show="!isDineInAndPrepaid")
    .bar_bg
    .bar_active(:style="{ width: style.width, background:style.background }")
</template>

<script>
import { mapState } from 'vuex'
import { t } from '@/utils/language'

export default {
  props: {
    // Pay first or pay later
    // 先付款或后付款
    type: {
      type: [Number, String],
      default: 1
    },

    // order status另外不需要
    status: {
      type: [Number, String],
      default: 40
    },

    // Payment status
    // 支付的状态
    payamentStatus: {
      type: [Number, String],
      default: 0
    },

    // Order Type dine-in, takeaway, delivery, pickup
    // 订单类型。值包括有 dine-in, takeaway, delivery, pickup。
    orderType: {
      type: String,
      default: ''
    },

    // Advance order time
    // 预订单的时间
    preOrderStartTime: {
      type: [String, Number],
      default: ''
    },

    showError: Boolean
  },

  computed: {

    ...mapState({
      stationSettings: state => state.venueHome.stationSettings,
    }),

    getStatusClass() {
      if (this.enableStation) {
        if (parseInt(this.status) === 30) {
          return 'green'
        } else if (parseInt(this.status) >= 40) {
          return 'dark_green'
        } else {
          return 'yellow'
        }
      }
      return ''
    },

    isDineInAndPrepaid() {
      const type = Number(this.type)
      return type === 0 && (this.orderType === 'dine-in' || this.orderType === 'takeaway')
    },

    enableStation() {
      return this.stationSettings.enableStation ?? false
    },

    style() {
      const status = Number(this.status)
      // 1: Pay first
      // 1: 先付款
      // 0: Pay later
      // 0: 后付款
      const type = Number(this.type) === 3 ? 3 : Number(this.type)
      const payamentStatus = Number(this.payamentStatus)
      // check is dine in and pre-paid
      const isDineInAndPrePaid = this.isDineInAndPrepaid
      const isStationEnable = this.enableStation

      // Advance Order Status
      // 预订单的状态
      if (type === 3 && !this.preOrderStartTime) {
        return {
          width: '0%',
          background: '',
          text: t('payment_received', 'Payment received'),
        }
      }
      if (status < 10) {
        if (payamentStatus !== 1) {
          // Pay first && No payment
          // 先付款 && 没有支付
          if (type === 0) {
            return {
              width: '25%',
              background: 'rgba(242, 171, 40, 1)',
              text: isDineInAndPrePaid ? t('order_received', 'Order received.') : t('preparing_your_order', 'We\'re preparing your order'),
            }
          } else {
          // Pay later && No payment
          // 后付款 && 没有支付
            return {
              width: '0%',
              background: 'rgba(152, 161, 169, 1)',
              text: t('awaiting_payment', 'Awaiting payment'),
            }
          }
        } else if (payamentStatus === 1) {
        // Advance payment has been paid, status === 0
        // 先付款已经支付, status === 0
          return {
            width: '25%',
            background: 'rgba(242, 171, 40, 1)',
            text: isStationEnable ? t('preparing', 'Preparing') : (isDineInAndPrePaid ? t('order_received', 'Order received.') : t('preparing_your_order', 'We\'re preparing your order')),
          }
        }
      } else if (status === 10 || status === 20) {
        return {
          width: type ? '25%' : '50%',
          background: 'rgba(242, 171, 40, 1)',
          text: isStationEnable ? t('preparing', 'Preparing') : (isDineInAndPrePaid ? t('order_received', 'Order received.') : t('preparing_your_order', 'We\'re preparing your order')),
        }
      } else if (status === 30) {
        return {
          width: type ? '50%' : '100%',
          background: 'rgba(23, 163, 65, 1)',
          text: isStationEnable ? t('ready', 'Ready') : (isDineInAndPrePaid ? t('order_received', 'Order received.') : (this.orderType === 'delivery' ? t('delivery_in_progress', 'Delivery in progress') : t('your_order_ready', 'Your order is ready'))),
        }
      } else if (status >= 40) {
        return {
          width: payamentStatus === 1 ? '100%' : '75%',
          background: payamentStatus === 1 ? 'rgba(51, 68, 85, 1)' : 'rgba(152, 161, 169, 1)',
          text: isStationEnable ? t('picked_up', 'Picked Up') : (payamentStatus === 1 ? (isDineInAndPrePaid ? t('order_received_closed', 'Order received and closed.') : t('paid_and_closed', 'Paid and closed')) : t('awaiting_payment', 'Awaiting payment')),
        }
      }

      return null
    }
  },

  methods: {
    t(key, fallback) {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t(key, fallback)
    }
  },
}
</script>
